<template>
  <div class="content">
    <div class="page-title flex align-center just-content-between">
      <div class="flex">
        <p>{{ pageTitle }}</p>
        <p class="u-ml30">{{ tabs + 1 }} / {{ tabsMax + 1 }}</p>
      </div>
      <div class="flex align-center u-ml40 u-mr20" style="font-size: 14px">
        <span class="icon">
          <font-awesome-icon icon="user" size="2x"></font-awesome-icon>
        </span>
        <p class="u-mr10 u-ml5 u-mb0">{{ schoolYear }}</p>
        <p class="u-mb0">{{ childName }}</p>
      </div>
    </div>
    <p class="prohibited-text">
      ※ブラウザの戻るボタン/再読み込みは使用しないでください。<br />入力中のデータが正しく処理されません。
    </p>
    <div class="form-wrap">
      <div class="tab -0" v-if="tabs === 0">
        <atoms-input-text
          class="u-mb30"
          label="記入者："
          type="text"
          placeholder="記入者"
          inputmode="text"
          :required="false"
          v-model="formData.writer"
          setKey="writer"
          @input-emit="handleUpdateValue"
        ></atoms-input-text>
        <section class="form-section u-mb20">

          <atoms-label label="動作" class="u-mb15" />

          <p class="u-mt20 u-mb0 bold">床上</p>

          <atoms-input-select
            class="u-mt10"
            label="寝返り"
            v-model="formData.motionTheFloorRollingOver"
            setKey="motionTheFloorRollingOver"
            :options="useDefine.defineObject.ROLLINGOVER_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="起き上がり"
            v-model="formData.motionTheFloorGetUp"
            setKey="motionTheFloorGetUp"
            :options="useDefine.defineObject.GETUP_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="座位保持"
            v-model="formData.motionTheFloorSittingPositionHeld"
            setKey="motionTheFloorSittingPositionHeld"
            :options="useDefine.defineObject.SITTINGPOSITIONHELD_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="立位保持"
            v-model="formData.motionTheFloorStandingHolding"
            setKey="motionTheFloorStandingHolding"
            :options="useDefine.defineObject.STANDINGHOLDING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="移乗"
            v-model="formData.motionTheFloorTransfer"
            setKey="motionTheFloorTransfer"
            :options="useDefine.defineObject.TRANSFER_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-textarea
            label="場所・補助具・介護状況など"
            placeholder="場所・補助具・介護状況など"
            :required="false"
            v-model="formData.motionTheFloorPlaceAuxiliaryEquipmentSituation"
            setKey="motionTheFloorPlaceAuxiliaryEquipmentSituation"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-radio
            label="エアーマットの使用"
            v-model="formData.motionTheFloorElectricBed"
            setKey="motionTheFloorElectricBed"
            :options="useDefine.defineObject.ELECTRICBED_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio>

          <atoms-input-radio
            label="電動ベッド"
            v-model="formData.motionTheFloorUseOfAirMat"
            setKey="motionTheFloorUseOfAirMat"
            :options="useDefine.defineObject.USEOFAIRMAT_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio>
        </section>
      </div>

      <div class="tab -1" v-if="tabs === 1">
        <div class="u-mb40">
          <p class="u-mt20 u-mb10 bold">移動</p>
          <atoms-input-select
            class="u-mt0"
            label="屋内"
            v-model="formData.motionMovementIndoor"
            setKey="motionMovementIndoor"
            :options="useDefine.defineObject.INDOOR_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="屋外"
            v-model="formData.motionMovementOutdoors"
            setKey="motionMovementOutdoors"
            :options="useDefine.defineObject.OUTDOORS_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-textarea
            label="補装具の使用（杖 短下肢装具 歩行器 車椅子 その他）"
            placeholder="補装具の使用（杖 短下肢装具 歩行器 車椅子 その他）"
            :required="false"
            v-model="formData.motionMovementUseOfProsthetics"
            setKey="motionMovementUseOfProsthetics"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </div>

        <div class="u-mb20">
          <p class="u-mt0 u-mb10 bold">入浴</p>
          <atoms-input-select
            class="u-mt0"
            label="浴槽出入り"
            v-model="formData.motionBathingTubAndOut"
            setKey="motionBathingTubAndOut"
            :options="useDefine.defineObject.TUBANDOUT_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="洗身"
            v-model="formData.motionBathingWashing"
            setKey="motionBathingWashing"
            :options="useDefine.defineObject.WASHING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="洗髪"
            v-model="formData.motionBathingShampoo"
            setKey="motionBathingShampoo"
            :options="useDefine.defineObject.SHAMPOO_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-textarea
            label="留意点（頻度等）"
            placeholder="留意点（頻度等）"
            :required="false"
            v-model="formData.motionBathingConsiderations"
            setKey="motionBathingConsiderations"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-select
            label="方法："
            v-model="formData.motionBathingMethod"
            setKey="motionBathingMethod"
            :options="useDefine.defineObject.METHOD_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <div class="input-wrap-group">
            <atoms-input-text
              label="現在の身長"
              type="text"
              inputmode="numeric"
              placeholder="100"
              :required="false"
              v-model="formData.motionBathingHeight"
              setKey="motionBathingHeight"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
            <span>cm</span>
          </div>

          <div class="input-wrap-group">
            <atoms-input-text
              label="現在の体重"
              type="text"
              inputmode="numeric"
              placeholder="30"
              :required="false"
              v-model="formData.motionBathingWeight"
              setKey="motionBathingWeight"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
            <span>kg</span>
          </div>
        </div>
      </div>

      <div class="tab -2" v-if="tabs === 2">
        <div class="u-mb20">
          <p class="u-mt20 u-mb10 bold">排泄</p>

          <atoms-input-select
            class="u-mt0"
            label="排尿"
            v-model="formData.motionExcretionUrination"
            setKey="motionExcretionUrination"
            :options="useDefine.defineObject.URINATION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-text
            label="回数："
            type="text"
            inputmode="numeric"
            placeholder="5"
            :required="false"
            v-model="formData.motionExcretionUrinationViews"
            setKey="motionExcretionUrinationViews"
            @input-emit="handleUpdateValue"
          ></atoms-input-text>

          <atoms-input-select
            label="尿意："
            v-model="formData.motionExcretionUrinationUrinate"
            setKey="motionExcretionUrinationUrinate"
            :options="useDefine.defineObject.URINATE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-radio
            label="伝達："
            v-model="formData.motionExcretionUrinationTransmission"
            setKey="motionExcretionUrinationTransmission"
            :options="useDefine.defineObject.TRANSMISSION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio>

          <atoms-input-select
            label="排便"
            v-model="formData.motionExcretionDefecation"
            setKey="motionExcretionDefecation"
            :options="useDefine.defineObject.DEFECATION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-text
            label="回数："
            type="text"
            inputmode="numeric"
            placeholder="1"
            :required="false"
            v-model="formData.motionExcretionDefecationViews"
            setKey="motionExcretionDefecationViews"
            @input-emit="handleUpdateValue"
          ></atoms-input-text>

          <atoms-input-select
            label="便意"
            v-model="formData.motionExcretionDefecationBowelMovement"
            setKey="motionExcretionDefecationBowelMovement"
            :options="useDefine.defineObject.BOWELMOVEMENT_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-radio
            label="伝達："
            v-model="formData.motionExcretionDefecationTransmission"
            setKey="motionExcretionDefecationTransmission"
            :options="useDefine.defineObject.TRANSMISSION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio>

          <atoms-input-select
            label="失禁："
            v-model="formData.motionExcretionDefecationIncontinence"
            setKey="motionExcretionDefecationIncontinence"
            :options="useDefine.defineObject.INCOUNTINENCE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="便通："
            v-model="formData.motionExcretionDefecationBowelMove"
            setKey="motionExcretionDefecationBowelMove"
            :options="useDefine.defineObject.BOWELMOVE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="間接支援"
            v-model="formData.motionExcretionIndirectSupport"
            setKey="motionExcretionIndirectSupport"
            :options="useDefine.defineObject.INDIRECTSUPPORT_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="方法"
            v-model="formData.motionExcretionMethod"
            setKey="motionExcretionMethod"
            :options="useDefine.defineObject.EXCRETIONMETHOD_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>
        </div>
      </div>

      <div class="tab -3" v-if="tabs === 3">
        <div class="u-mb20">
          <p class="u-mt20 u-mb10 bold">食事</p>
          <atoms-input-select
            class="u-mt0"
            label="食事摂取"
            v-model="formData.motionMealDietaryIntake"
            setKey="motionMealDietaryIntake"
            :options="useDefine.defineObject.DIETARYINTAKE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="飲水"
            v-model="formData.motionMealDrinkingWater"
            setKey="motionMealDrinkingWater"
            :options="useDefine.defineObject.DRINKINGWATER_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="嚥下"
            v-model="formData.motionMealSwallowing"
            setKey="motionMealSwallowing"
            :options="useDefine.defineObject.SWALLOWING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="食事形態"
            v-model="formData.motionMealMealForm"
            setKey="motionMealMealForm"
            :options="useDefine.defineObject.MEALFORM_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-radio
            label="自助具の使用"
            v-model="formData.motionMealUseOfSelfHelpTool"
            setKey="motionMealUseOfSelfHelpTool"
            :options="useDefine.defineObject.USEOFSELFHELPTOOL_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio>

          <atoms-input-select
            label="自助具の使用有"
            v-model="formData.motionMealUseOrganicSelfHelpTool"
            setKey="motionMealUseOrganicSelfHelpTool"
            :options="
              useDefine.defineObject.USEORGANICSELFHELPTOOL_OPTION_ARRAY
            "
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-textarea
            label="栄養状態"
            placeholder="栄養状態"
            :required="false"
            v-model="formData.motionMealNutritionalStatus"
            setKey="motionMealNutritionalStatus"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-select
            label="食事内容"
            v-model="formData.motionMealDiet"
            setKey="motionMealDiet"
            :options="useDefine.defineObject.DIET_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-textarea
            label="特別食"
            placeholder="特別食"
            :required="false"
            v-model="formData.motionMealSpecialDietMenus"
            setKey="motionMealSpecialDietMenus"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-text
            label="食事回数："
            type="text"
            inputmode="numeric"
            placeholder="3"
            :required="false"
            v-model="formData.motionMealMealTimes"
            setKey="motionMealMealTimes"
            @input-emit="handleUpdateValue"
          ></atoms-input-text>

          <atoms-input-text
            label="食欲："
            type="text"
            inputmode="text"
            placeholder="食欲あり"
            :required="false"
            v-model="formData.motionMealAppetite"
            setKey="motionMealAppetite"
            @input-emit="handleUpdateValue"
          ></atoms-input-text>
        </div>
      </div>

      <div class="tab -4" v-if="tabs === 4">
        <div class="u-mb40">
          <p class="u-mt20 u-mb10 bold">清潔</p>
          <atoms-input-select
            class="u-mt0"
            label="口腔清潔"
            v-model="formData.motionCleanlinessOralCleanliness"
            setKey="motionCleanlinessOralCleanliness"
            :options="useDefine.defineObject.CLEANLINESS_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="洗顔"
            v-model="formData.motionCleanlinessCleansing"
            setKey="motionCleanlinessCleansing"
            :options="useDefine.defineObject.CLEANLINESS_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="整髪"
            v-model="formData.motionCleanlinessHairdressing"
            setKey="motionCleanlinessHairdressing"
            :options="useDefine.defineObject.CLEANLINESS_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="爪切り"
            v-model="formData.motionCleanlinessNailClippers"
            setKey="motionCleanlinessNailClippers"
            :options="useDefine.defineObject.CLEANLINESS_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>
        </div>

        <div class="u-mb40">
          <p class="u-mt0 u-mb10 bold">着脱</p>

          <atoms-input-select
            class="u-mt0"
            label="上着"
            v-model="formData.motionRemovableJacket"
            setKey="motionRemovableJacket"
            :options="useDefine.defineObject.REMOVABLE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="ズボン等"
            v-model="formData.motionRemovableTrousers"
            setKey="motionRemovableTrousers"
            :options="useDefine.defineObject.REMOVABLE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>
        </div>

        <div class="u-mb20">
          <p class="u-mt0 u-mb10 bold">I-ADL</p>
          <atoms-input-select
            class="u-mt0"
            label="洗濯"
            v-model="formData.motionIAdlWashing"
            setKey="motionIAdlWashing"
            :options="useDefine.defineObject.IADL_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="掃除"
            v-model="formData.motionIAdlCleanUp"
            setKey="motionIAdlCleanUp"
            :options="useDefine.defineObject.IADL_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="整理・整頓"
            v-model="formData.motionIAdlOrganizeAndTidy"
            setKey="motionIAdlOrganizeAndTidy"
            :options="useDefine.defineObject.IADL_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="買物"
            v-model="formData.motionIAdlShopping"
            setKey="motionIAdlShopping"
            :options="useDefine.defineObject.IADL_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="調理"
            v-model="formData.motionIAdlCooking"
            setKey="motionIAdlCooking"
            :options="useDefine.defineObject.IADL_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="金銭管理"
            v-model="formData.motionIAdlMoneyManagement"
            setKey="motionIAdlMoneyManagement"
            :options="useDefine.defineObject.IADL_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="電話の利用"
            v-model="formData.motionIAdlUseOfTelephone"
            setKey="motionIAdlUseOfTelephone"
            :options="useDefine.defineObject.IADL_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>
        </div>
      </div>

      <div class="tab -5" v-if="tabs === 5">
        <div class="u-mb20">
          <p class="u-mt20 u-mb10 bold">コミュニケーションスキル</p>
          <div class="form-content u-mt30">
            <p class="form-content-title">視力</p>

            <atoms-input-select
              class="u-mt0"
              label="視力"
              v-model="formData.motionCommunicationSkillsEyesight"
              setKey="motionCommunicationSkillsEyesight"
              :options="useDefine.defineObject.EYESIGHT_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-check-box
              label="視覚障害："
              v-model="formData.motionCommunicationSkillsVisuallyImpaired"
              setKey="motionCommunicationSkillsVisuallyImpaired"
              :options="useDefine.defineObject.DISABILITY_RIGHT_AND_LEFT"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-check-box>

            <atoms-input-radio
              label="白杖の利用："
              v-model="formData.motionCommunicationSkillsUseOfWhiteCane"
              setKey="motionCommunicationSkillsUseOfWhiteCane"
              :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
          </div>

          <div class="form-content u-mt30">
            <p class="form-content-title u-mb0">聴力</p>

            <atoms-input-select
              class="u-mt0"
              label="聴力"
              v-model="formData.motionCommunicationSkillsHearing"
              setKey="motionCommunicationSkillsHearing"
              :options="useDefine.defineObject.HEARING_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-check-box
              label="聴覚障害："
              v-model="formData.motionCommunicationSkillsHearingImpairment"
              setKey="motionCommunicationSkillsHearingImpairment"
              :options="useDefine.defineObject.DISABILITY_RIGHT_AND_LEFT"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-check-box>

            <atoms-input-radio
              label="補聴器："
              v-model="formData.motionCommunicationSkillsHearingAid"
              setKey="motionCommunicationSkillsHearingAid"
              :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="手話："
              v-model="formData.motionCommunicationSkillsSignLanguage"
              setKey="motionCommunicationSkillsSignLanguage"
              :options="useDefine.defineObject.PROPRIETY_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
          </div>

          <div class="form-content u-mt30">
            <p class="form-content-title u-mb0">意思の伝達</p>

            <atoms-input-select
              label="意思の伝達"
              v-model="
                formData.motionCommunicationSkillsTransmissionOfIntention
              "
              setKey="motionCommunicationSkillsTransmissionOfIntention"
              :options="
                useDefine.defineObject.TRANSMISSIONOFINTENTION_OPTION_ARRAY
              "
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-radio
              label="言語障害："
              v-model="formData.motionCommunicationSkillsLanguageDisorders"
              setKey="motionCommunicationSkillsLanguageDisorders"
              :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>
          </div>

          <atoms-input-textarea
            label="コミュニケーション機器"
            placeholder="コミュニケーション機器"
            :required="false"
            v-model="formData.motionCommunicationSkillsCommunicationEquipment"
            setKey="motionCommunicationSkillsCommunicationEquipment"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-select
            label="理解度"
            v-model="formData.motionCommunicationSkillsLevelOfUnderstanding"
            setKey="motionCommunicationSkillsLevelOfUnderstanding"
            :options="useDefine.defineObject.LEVELOFUNDERSTANDING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="話す"
            v-model="formData.motionCommunicationSkillsSpeak"
            setKey="motionCommunicationSkillsSpeak"
            :options="useDefine.defineObject.SPEAK_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="書く"
            v-model="formData.motionCommunicationSkillsWrite"
            setKey="motionCommunicationSkillsWrite"
            :options="useDefine.defineObject.WRITE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="読む"
            v-model="formData.motionCommunicationSkillsRead"
            setKey="motionCommunicationSkillsRead"
            :options="useDefine.defineObject.READ_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-radio
            label="認知症症状："
            v-model="formData.motionCommunicationSkillsDementiaSymptoms"
            setKey="motionCommunicationSkillsDementiaSymptoms"
            :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio>

          <atoms-input-radio
            label="精神症状："
            v-model="formData.motionCommunicationSkillsPsychiatricSymptoms"
            setKey="motionCommunicationSkillsPsychiatricSymptoms"
            :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio>

          <atoms-input-radio
            label="知的障害："
            v-model="formData.motionCommunicationSkillsIntellectualDisability"
            setKey="motionCommunicationSkillsIntellectualDisability"
            :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio>

          <atoms-input-radio
            label="要配慮行動"
            v-model="formData.motionBehaviorRequiringConsideration"
            setKey="motionBehaviorRequiringConsideration"
            :options="useDefine.defineObject.PRESENCEORABSENCE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio>

          <atoms-input-textarea
            label="none"
            placeholder="要配慮行動について"
            :required="false"
            v-model="
              formData.motionBehaviorRequiringConsiderationHaveIntellectualDisability
            "
            setKey="motionBehaviorRequiringConsiderationHaveIntellectualDisability"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </div>
      </div>
      <div class="check_button_wrap prev_and_next">
        <div class="prev">
          <atoms-note-button
            v-if="tabs > tabsMin"
            buttonText="前の項目へ"
            @confirm="handlePrevTabs"
          />
        </div>
        <div class="next">
          <atoms-note-button
            v-if="tabs < tabsMax"
            buttonText="次の項目へ"
            @confirm="handleNextTabs"
          />
        </div>
      </div>
    </div>
    <div class="form-tabs" v-if="nextPageTitle">
      <atoms-note-button
        :buttonText="`${nextPageTitle}へ`"
        @confirm="handleUpdateFormTab"
      />
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'
import formUtils from '@/lib/formUtils/form-utils'

export default {
  data() {
    return {
      tabsMin: 0,
      tabsMax: 5,
      tabs: 0,
      // formの選択肢
      useDefine: { defineObject: defineObject },
      // emit対象のformデータ
      formData: {
        createdDate: '',
        lastName: '',
        firstName: '',
        writer: '',
        motionTheFloorRollingOver: '',
        motionTheFloorGetUp: '',
        motionTheFloorSittingPositionHeld: '',
        motionTheFloorStandingHolding: '',
        motionTheFloorTransfer: '',
        motionTheFloorPlaceAuxiliaryEquipmentSituation: '',
        motionTheFloorElectricBed: '',
        motionTheFloorUseOfAirMat: '',
        motionMovementIndoor: '',
        motionMovementOutdoors: '',
        motionMovementUseOfProsthetics: '',
        motionBathingTubAndOut: '',
        motionBathingWashing: '',
        motionBathingShampoo: '',
        motionBathingConsiderations: '',
        motionBathingMethod: '',
        motionBathingHeight: '',
        motionBathingWeight: '',
        motionExcretionUrination: '',
        motionExcretionUrinationViews: '',
        motionExcretionUrinationUrinate: '',
        motionExcretionUrinationTransmission: '',
        motionExcretionDefecation: '',
        motionExcretionDefecationViews: '',
        motionExcretionDefecationBowelMovement: '',
        motionExcretionDefecationTransmission: '',
        motionExcretionDefecationIncontinence: '',
        motionExcretionDefecationBowelMove: '',
        motionExcretionIndirectSupport: '',
        motionExcretionMethod: '',
        motionMealDietaryIntake: '',
        motionMealDrinkingWater: '',
        motionMealSwallowing: '',
        motionMealMealForm: '',
        motionMealUseOfSelfHelpTool: '',
        motionMealUseOrganicSelfHelpTool: '',
        motionMealNutritionalStatus: '',
        motionMealDiet: '',
        motionMealSpecialDietMenus: '',
        motionMealMealTimes: '',
        motionMealAppetite: '',
        motionCleanlinessOralCleanliness: '',
        motionCleanlinessCleansing: '',
        motionCleanlinessHairdressing: '',
        motionCleanlinessNailClippers: '',
        motionRemovableJacket: '',
        motionRemovableTrousers: '',
        motionIAdlWashing: '',
        motionIAdlCleanUp: '',
        motionIAdlOrganizeAndTidy: '',
        motionIAdlShopping: '',
        motionIAdlCooking: '',
        motionIAdlMoneyManagement: '',
        motionIAdlUseOfTelephone: '',
        motionCommunicationSkillsEyesight: '',
        motionCommunicationSkillsVisuallyImpaired: '',
        motionCommunicationSkillsUseOfWhiteCane: '',
        motionCommunicationSkillsHearing: '',
        motionCommunicationSkillsHearingImpairment: '',
        motionCommunicationSkillsHearingAid: '',
        motionCommunicationSkillsSignLanguage: '',
        motionCommunicationSkillsTransmissionOfIntention: '',
        motionCommunicationSkillsLanguageDisorders: '',
        motionCommunicationSkillsCommunicationEquipment: '',
        motionCommunicationSkillsLevelOfUnderstanding: '',
        motionCommunicationSkillsSpeak: '',
        motionCommunicationSkillsWrite: '',
        motionCommunicationSkillsRead: '',
        motionCommunicationSkillsDementiaSymptoms: '',
        motionCommunicationSkillsPsychiatricSymptoms: '',
        motionCommunicationSkillsIntellectualDisability: '',
        motionBehaviorRequiringConsideration: '',
        motionBehaviorRequiringConsiderationHaveIntellectualDisability: '',
      },
    }
  },
  props: {
    propsFormData: {
      type: Object,
      required: true,
    },
    setObjectKey: {
      type: String,
      required: true,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    nextPageTitle: {
      type: String,
      required: false,
    },
    childName: {
      type: String,
      required: false,
    },
    schoolYear: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleUpdateValue(setKey, setVal) {
      this.formData[setKey] = setVal
      this.$emit('input-emit', this.setObjectKey, setKey, setVal)
    },
    handlePrevTabs() {
      this.handleSmoothScroll()
      this.tabs--
    },
    handleNextTabs() {
      this.handleSmoothScroll()
      this.tabs++
    },
    handleSmoothScroll() {
      this.$smoothScroll({
        scrollTo: document.getElementById('app'), // scrollTo is also allowed to be number
      })
    },
    handleUpdateFormTab() {
      this.$emit('click-tab-switch', this.setObjectKey)
    },
  },
  mounted() {
    Object.keys(this.formData).forEach(key => {
      if (this.propsFormData[key]) {
        this.formData[key] = this.propsFormData[key]
      }

      this.handleUpdateValue(key, this.formData[key])
    })

    if (!this.formData.createdDate) {
      this.formData.createdDate = formUtils.handleSetJapaneseCalendar(
        new Date(),
        '',
        'none'
      )
      this.handleUpdateValue('createdDate', this.formData.createdDate)
    }
  },
}
</script>
<style lang="scss" scoped>
.form-tabs {
  margin: 0 auto;
  max-width: 460px;
  button {
    width: 100%;
  }
}
</style>
